/* eslint-disable @typescript-eslint/no-explicit-any -- redux connect generic helper */
import { ComponentType } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { DispatchProps } from './types'

export type InferConnectedProps<
  TConnector extends ReturnType<typeof connect>,
  TActions extends Record<string, (...args: any[]) => any>,
> = Omit<ConnectedProps<TConnector>, keyof TActions> & DispatchProps<TActions>

export function createConnector<
  TConnector extends ReturnType<typeof connect>,
  TComponentProps = any,
  TReduxProps = any,
>(
  connector: TConnector,
  component: ComponentType<TComponentProps>,
): ComponentType<Omit<TComponentProps, keyof TReduxProps>> {
  return connector(component as any) as ComponentType<Omit<TComponentProps, keyof TReduxProps>>
}
